// extracted by mini-css-extract-plugin
module.exports = {"Safe":"Safe_Safe__6mqQJ"};